/**
 * Visit history tracker for the LLD Practice workspace.
 * Records section visits with monotonically-increasing timestamps.
 * Pure functions with no side effects.
 */

import { SectionId } from './sectionStateMachine';

export interface VisitEntry {
 section: SectionId;
 timestamp: number;
}

/**
 * Records a visit by appending an entry to the history.
 * Enforces monotonically-increasing timestamps: if the provided timestamp
 * is not greater than the last entry's timestamp, it is adjusted to
 * lastTimestamp + 1 to maintain ordering.
 *
 * @param history - The existing visit history array
 * @param section - The section being visited
 * @param timestamp - The timestamp of the visit (in milliseconds)
 * @returns A new history array with the visit appended
 */
export function recordVisit(
 history: VisitEntry[],
 section: SectionId,
 timestamp: number
): VisitEntry[] {
 let adjustedTimestamp = timestamp;

 if (history.length > 0) {
  const lastTimestamp = history[history.length - 1].timestamp;
  if (timestamp <= lastTimestamp) {
   adjustedTimestamp = lastTimestamp + 1;
  }
 }

 return [...history, { section, timestamp: adjustedTimestamp }];
}
